import { SHARED_SOURCING_AVAILABLE_CHANNELS } from 'modules/sourcing-shared/constants';

type HasSourcingSharedChannelSelectionEnabledProps = {
  isChannelSelectionFeatureFlagEnabled: boolean;
  organizationChannelsEnabled: string[];
};

export const hasSourcingSharedChannelSelectionEnabled = ({
  isChannelSelectionFeatureFlagEnabled,
  organizationChannelsEnabled
}: HasSourcingSharedChannelSelectionEnabledProps): boolean => {
  // Don't show channel selection step if feature flag is disabled
  if (!isChannelSelectionFeatureFlagEnabled) return false;

  const availableChannels = SHARED_SOURCING_AVAILABLE_CHANNELS.filter(
    (channel) => organizationChannelsEnabled.includes(channel)
  );

  // Don't show channel selection step if there is only one channel enabled
  if (availableChannels.length <= 1) return false;

  // Show channel selection step if there are multiple channels enabled
  return true;
};
